// extracted by mini-css-extract-plugin
export default {"napsa-header":"NapsaReport_napsa-header__E3AQ5","divider":"NapsaReport_divider__R9H7K"};